export default __webpack_public_path__ + "static/media/Directory.54b2768a.svg";